export const TOAST_LOCATION = {
  CENTER_BOTTOM: 'centerBottom',
  RIGHT_BOTTOM: 'rightBottom',
  RIGHT_TOP: 'rightTop',
};
